import { useSearchParams } from 'react-router'

import { redirectToLogin } from '@fv/client-core'

export const Login = () => {
  const [params] = useSearchParams()
  const redirect = params.get('redirect')
  redirectToLogin(redirect)

  return <div>Signing in...</div>
}
